var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "interface-upload-button-1 1",
    clipPath: "url(#clip0_654_40190)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.2861 12.0004L10.2861 13.1433C10.2861 13.2948 10.2259 13.4402 10.1188 13.5473C10.0116 13.6545 9.86626 13.7147 9.7147 13.7147L1.14327 13.7147C0.991722 13.7147 0.846377 13.6545 0.739213 13.5473C0.63205 13.4402 0.571846 13.2948 0.571846 13.1433L0.571847 2.85756C0.571847 2.70601 0.63205 2.56066 0.739214 2.4535C0.846377 2.34634 0.991723 2.28613 1.14328 2.28613L9.7147 2.28613C9.86626 2.28613 10.0116 2.34634 10.1188 2.4535C10.2259 2.56066 10.2861 2.70601 10.2861 2.85756L10.2861 4.00042",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.42871 8L15.4287 8",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.143 5.71484L15.4287 8.00056L13.143 10.2863",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_654_40190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(16) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitIcon);
export default __webpack_public_path__ + "static/media/exitIcon.a4a9e63c97342faad078f5105e70050b.svg";
export { ForwardRef as ReactComponent };